import {Card, Col, Row} from "antd";
import {Avatar, Chip} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    container: {
        width: 400,
        margin: 10,
        cursor: "pointer"
    },
    avatar: {
        height: 100,
        width: 100
    },
    detailDiv: {
        marginLeft: 10
    },
    detailElement: {
        margin: 5,
        width: 200,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip",
    }
}))

export default function UserCard({user}) {
    const classes = useStyles();

    return (
        <Box className={classes.container} boxShadow={2}>
            <Card >
                <Row>
                    <Col>
                        <Avatar variant='square' className={classes.avatar} src={user.photoURL}/>
                    </Col>
                    <Col className={classes.detailDiv}>
                        <Row className={classes.detailElement}>
                            <small>{user.email}</small>
                        </Row>
                        <Row className={classes.detailElement}>
                            <h5>{user.displayName ?? user.email}</h5>
                        </Row>
                        <Row className={classes.detailElement}>
                            <Chip label={user.disabled ? 'Desactive' : 'Actif'} color={user.disabled ? 'secondary' : 'primary'}/>
                        </Row>
                    </Col>
                </Row>
            </Card>
        </Box>

    )
}